/*
 * @Author: 黄智强
 * @Date: 2018-01-27 09:59:30
 * @Last Modified by: 黄智强
 * @Last Modified time: 2018-01-27 11:07:12
 * @说明：图片验证码接口地址
 */
// 获取图片验证码url,token
export const index = '/verify-image/index'
// 验证图片验证码
export const check = '/verify-image/check'



// WEBPACK FOOTER //
// ./src/api/url/verifyImage.js